import { Component, Output, EventEmitter } from '@angular/core';
import { AlertController } from 'ionic-angular';
import _ from 'lodash';
import { SettingsProvider } from '../../providers/settings/settings';

/**
 * Generated class for the FilterSettingsComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'filter-settings',
  templateUrl: 'filter-settings.html'
})
export class FilterSettingsComponent {
  static readonly showTrademarksSettingsKey: "showTrademarks" = "showTrademarks";
  private static readonly initialSettings: Readonly<DrugFilterSettings> = { showTrademarks: true };

  private current: DrugFilterSettings = _.clone(FilterSettingsComponent.initialSettings);

  public get highlightButton(): boolean {
    return this.current.showTrademarks;
  }


  @Output()
  change = new EventEmitter<DrugFilterSettings>();

  constructor(private alertCtrl: AlertController, private settingsProvider: SettingsProvider) {
    this.updateFromSettings();
  }

  private updateFromSettings() {
    const showTrademarksRemembered = this.settingsProvider.getLocalBool(FilterSettingsComponent.showTrademarksSettingsKey);
    if (showTrademarksRemembered !== null) {
      this.current.showTrademarks = showTrademarksRemembered;
    }
  }

  toggleShowTrademarks() {
    this.updateFromSettings();
    this.changeSettings({ showTrademarks: !this.current.showTrademarks });
  }

  private changeSettings(settings: DrugFilterSettings) {
    this.current = settings;
    this.settingsProvider.setLocalBool(FilterSettingsComponent.showTrademarksSettingsKey, this.current.showTrademarks);
    this.change.emit(this.current);
  }
}

export interface DrugFilterSettings {
  showTrademarks: boolean;
}


// WEBPACK FOOTER //
// ./src/components/filter-settings/filter-settings.ts